<!--Order-->
<div class="td col-id">

  @if (order.status !== 'Canceled') {
    <app-oms-order-action-menu [order]="order"
                               [canRecover]="canRecover"
                               [deliverySchedulingStateReference]="order.deliverySchedulingStateReference"
                               (onSendToDispatch)="onSendToDispatch.emit($event)"
                               (onAddNote)="onAddNote.emit($event)"
                               (onSetOrderOnHold)="onSetOrderOnHold.emit($event)"
                               (onResumeOrder)="onResumeOrder.emit($event)"
                               (onManuallyCompleteOrder)="onManuallyCompleteOrder.emit($event)"
                               (onEdit)="onEdit.emit($event)"
                               (onDuplicate)="onDuplicate.emit($event)"
                               (onPrintBillOfLading)="onPrintBillOfLading.emit($event)"
                               (onDownloadBillOfLading)="onDownloadBillOfLading.emit($event)"
                               (onSendSchedulingSMSClicked)="onSendSchedulingSMSClicked.emit($event)"
                               (onSendSchedulingWhatsappClicked)="onSendSchedulingWhatsappClicked.emit($event)"
                               (onViewSchedulingLink)="onViewSchedulingLink.emit()"
                               (onRecover)="onRecover.emit($event)"
                               (onCancelOrder)="onCancelOrder.emit($event)">
    </app-oms-order-action-menu>
  } @else {
    <div class="action-menu-placeholder"></div>
  }

  <bz-checkbox size="sm"
               class="select-checkbox"
               appBringozIdGenerator="oms-orders-row-select-checkbox"
               [ariaLabel]="'Select Order' | translate"
               [checked]="isSelected"
               (checkedChange)="onToggleSelect.emit(order)">
  </bz-checkbox>

  <div class="flex layout-column min-width-0">

    <div class="layout-row layout-align-start-start">

      <div class="layout-row layout-align-start-start text-ellipsis"
           (mouseenter)="canCopyOrderId = true"
           (mouseleave)="canCopyOrderId = false">
        <app-bringoz-state-link class="text-ellipsis"
                                [permission]="'oms.orders.get'"
                                [state]="'order.info'"
                                [params]="{id: order.id}"
                                [text]="order.id">
        </app-bringoz-state-link>

        @if (canCopyOrderId) {
          <app-text-copy-button [text]="order.id" [isShowCopyBtn]="true"></app-text-copy-button>
        }
      </div>

      @if (order.itemLines) {
        <app-activity-packed-indication class="margin-right-5 margin-left-5"
                                        [isPacked]="order.packed"
                                        [packages]="order.itemLines"
                                        [stopType]="order.status">
        </app-activity-packed-indication>
      }

      @if (fulfillmentLine?.pickupTask?.obligateTimeWindow || fulfillmentLine?.destinationTask?.obligateTimeWindow) {
        <bringoz-icon iconName="obligate" class="gray-102 margin-left-5" [ngbTooltip]="'Guarantee' | translate"
                      openDelay="300"
                      container="body"
                      triggers="hover">
        </bringoz-icon>
      }

      @if (fulfillmentLine?.pickupTask?.schedulingRequired || fulfillmentLine?.destinationTask?.schedulingRequired) {
        <bringoz-icon iconName="schedule-call" class="md-warn margin-left-5"
                      [ngClass]="{'green': order.status === 'Completed' || order.status === 'Scheduled'}"
                      [ngbTooltip]="'Schedule required' | translate" openDelay="300"
                      container="body"
                      triggers="hover">
        </bringoz-icon>
      }

    </div>

    @if (order.externalId) {
      <div class="layout-row layout-align-start-start"
           (mouseenter)="canCopyOrderExternalId = true"
           (mouseleave)="canCopyOrderExternalId = false">
        <app-bringoz-state-link class="text-ellipsis"
                                [permission]="'oms.orders.get'"
                                [state]="'order.info'"
                                [params]="{id: order.id}"
                                [text]="order.externalId">
        </app-bringoz-state-link>

        @if (canCopyOrderExternalId) {
          <app-text-copy-button [text]="order.externalId" [isShowCopyBtn]="true"></app-text-copy-button>
        }
      </div>
    }

    <app-bringoz-status-tag [status]="order.status" [entity]="'order'"
                            class="margin-top-5"></app-bringoz-status-tag>

  </div>

</div>

<!--Account-->
@if (columns?.account?.enabled) {
  <div class="td col-account">
    <div class="layout-column gap-5 min-width-0">

      <div class="layout-row layout-align-start-center"
           (mouseenter)="canCopyAccount = true; canFilterByAccount = true"
           (mouseleave)="canCopyAccount = false; canFilterByAccount = false">
        <app-bringoz-state-link class="text-ellipsis"
                                [permission]="'accounts.demand.get'"
                                [state]="'accounts-detail-demand.info.preferences'"
                                [params]="{id: order.accountReference.id}"
                                [text]="order.accountReference.name">
        </app-bringoz-state-link>

        @if (canCopyAccount) {
          <app-text-copy-button [text]="order.accountReference.id" [isShowCopyBtn]="true"></app-text-copy-button>
        }

        @if (canFilterByAccount) {
          <bringoz-button (onClick)="onFilterByType.emit({type: siteFiltersType.accountIds, value: order.accountReference.id}); $event.stopPropagation();"
                          type="tertiary">
            <bringoz-icon iconName="filter" class="gray-102"></bringoz-icon>
          </bringoz-button>
        }
      </div>

      <div class="layout-row layout-align-start-center">
        <app-bringoz-tags [tags]="order.accountReference.tags" maxTags="2"></app-bringoz-tags>
      </div>

    </div>
  </div>
}

<!--Account External ID-->
@if (columns?.accountExternalId?.enabled) {
  <div class="td col-account-external-id">
    <span class="br-body-2 text-ellipsis">{{ order.accountReference?.externalId }}</span>
  </div>
}

<!--Branches-->
@if (columns?.branches?.enabled) {
  <div class="td col-branches">
    <branches-indicator [branches]="order.branchReferences"></branches-indicator>
  </div>
}

<!--Contact, one line per task (pickup, destination)-->
@if (columns?.contact?.enabled) {
  <div class="td col-contact">
    <div class="layout-column gap-5 min-width-0">
      @for (task of tasks; track $index) {
        <div class="layout-row min-width-0">
          <span appBringozPpi class="br-body-2 text-ellipsis">{{ task.contact?.name || '---' }}</span>
          @if (task.contact?.businessName) {
            <span appBringozPpi class="margin-left-5 text-ellipsis">/ {{ task.contact?.businessName }}</span>
          }
        </div>
      }
    </div>
  </div>
}

<!--Phone, one line per task (pickup, destination)-->
@if (columns?.phone?.enabled) {
  <div class="td col-phone">
    <div class="layout-column gap-5 min-width-0">
      @for (task of tasks; track $index) {
        <div class="layout-row min-width-0"
             [ngbTooltip]="task.contact?.phoneNo || task.contact?.additionalPhoneNo ? tooltipTmpl : null" openDelay="300"
             triggers="hover" container="body">
          @if (task.contact?.phoneNo || task.contact?.additionalPhoneNo; as phoneNo) {
            <span appBringozPpi class="br-body-2 text-ellipsis">{{ phoneNo | bringozPhone }}</span>
          } @else {
            <span class="br-body-2">---</span>
          }

          <ng-template #tooltipTmpl>
            <div class="layout-column">
              @if (task.contact?.phoneNo) {
                <span appBringozPpi>{{ task.contact.phoneNo | bringozPhone }}</span>
              }
              @if (task.contact?.additionalPhoneNo) {
                <span appBringozPpi>{{ task.contact.additionalPhoneNo | bringozPhone }}</span>
              }
            </div>
          </ng-template>
        </div>
      }
    </div>
  </div>
}

<!--Location, one line per task (pickup, destination)-->
@if (columns?.location?.enabled) {
  <div class="td col-location">
    <div class="layout-column gap-5 min-width-0">
      @for (task of tasks; track $index) {
        <div class="layout-row layout-align-start-center min-width-0">
          @if (task.location?.locationType === locationTypes.DEPOT) {
            <div class="layout-row layout-align-start-center min-width-0"
                 [ngbTooltip]="task.location?.address | bringozAddress"
                 openDelay="300"
                 triggers="hover" container="body">
              <app-task-purpose [purpose]="task.purpose" [firstLetterOnly]="true"></app-task-purpose>
              <bringoz-icon iconName="depot" class="gray-102 margin-left-5"></bringoz-icon>
              <span class="br-body-2 margin-left-5 text-ellipsis">{{ task.contact?.name }}</span>
            </div>
          } @else {
            <div class="layout-row layout-align-start-center min-width-0"
                 [ngbTooltip]="task.location?.address | bringozAddress"
                 openDelay="300"
                 triggers="hover" container="body">
              @if (task.location?.address) {
                <app-task-purpose [purpose]="task.purpose" [firstLetterOnly]="true"></app-task-purpose>
              } @else {
                <bringoz-icon iconName="location-required" class="margin-left-5 gray-102"></bringoz-icon>
              }

              <span class="br-body-2 text-ellipsis margin-left-5"
                    [ngClass]="{'no-address': !task.location?.address}">{{ task.location?.address | bringozAddress }}</span>
            </div>

            @if (task.location?.address?.qualityGroup) {
              <app-address-quality [address]="task.location?.address"></app-address-quality>
            }
          }
        </div>
      }
    </div>
  </div>
}

<!--Relations-->
@if (columns?.relations?.enabled) {
  <div class="td col-relations">
    @if (order.blockedByOrders?.length) {
      <div class="flex layout-column gap-5 min-width-0">
        <span class="br-body-2">{{ 'BlockedBy' | translate }}</span>
        @for (blockedOrder of order.blockedByOrders; track $index) {
          <app-oms-order-link [internalId]="blockedOrder?.omsOrderId"
                              [externalId]="blockedOrder?.externalId">
          </app-oms-order-link>
        }
      </div>
    }
  </div>
}

<!--Program-->
@if (columns?.programType?.enabled) {
  <div class="td col-program-type">
    <div class="layout-column min-width-0">
      @for (line of order.fulfillmentLines; track $index) {
        <div class="layout-row layout-align-start-center text-ellipsis">
          <span class="br-body-2">{{ line.programName }}</span>
          @if (line.programName && line.programType) {
            <span class="br-body-2"> / </span>
          }
          <span class="br-body-2">{{ line.programType }}</span>
        </div>
      }
    </div>
  </div>
}

<!--SLA-->
@if (columns?.sla?.enabled) {
  <div class="td col-sla">
    <span class="br-body-2 text-ellipsis">{{ order | bringozFullDate: 'dueTo' }} {{ order | bringozTime: 'dueTo' }}</span>
  </div>
}

<!--Time To Deliver-->
@if (columns?.timeToDeliver?.enabled) {
  <div class="td col-time-to-deliver">
    <span class="br-body-2 text-ellipsis">{{ order.dueTo ? (order.dueTo | bringozTimeAgo) : '---' }}</span>
  </div>
}

<!--Fulfillment Status-->
@if (columns?.fulfillmentStatus?.enabled) {
  <div class="td col-fulfillment-status">
    <app-bringoz-status-tag [status]="fulfillmentLine?.displayStatus"></app-bringoz-status-tag>
  </div>
}

<!--Reference ids-->
@if (columns?.referenceIds?.enabled) {
  <div class="td col-reference-ids">
    <app-bringoz-items-list-display [items]="order.referenceIds" [maxItems]="1"></app-bringoz-items-list-display>
  </div>
}

<!--Created Time-->
@if (columns?.createdAt?.enabled) {
  <div class="td col-created-at">
    <div class="layout-column min-width-0">
      <span class="br-body-2 text-ellipsis">{{ order | bringozTime: 'createdAt' }}</span>
      <span class="br-body-2 text-ellipsis">{{ order | bringozFullDate: 'createdAt' }}</span>
    </div>
  </div>
}

<!--PRO Number-->
@if (columns?.proNumber?.enabled) {
  <div class="td col-pro-number"
       (mouseenter)="canCopyProNumber = true"
       (mouseleave)="canCopyProNumber = false">
    <span class="text-ellipsis"
          [ngbTooltip]="fulfillmentLine?.proNumber || null"
          openDelay="300"
          container="body"
          triggers="hover">{{ fulfillmentLine?.proNumber || '---' }}</span>

    @if (canCopyProNumber && fulfillmentLine?.proNumber) {
      <app-text-copy-button [text]="fulfillmentLine.proNumber" [isShowCopyBtn]="true"></app-text-copy-button>
    }
  </div>
}

<!--Scheduling SMS-->
@if (columns?.schedulingSms?.enabled) {
  <div class="td col-scheduling-sms">
    @if (order.deliverySchedulingStateReference; as scheduling) {
      <div class="br-body-2 layout-column min-width-0">
        <span class="text-ellipsis">{{ 'SCHEDULING_SMS.' + scheduling.status | translate }}</span>
        <div class="text-ellipsis">
          @if (scheduling.numSmsSent) {
            <span class="margin-right-5">{{ 'Sms Sent On' | translate }}</span>
          }
          @if (scheduling.numWhatsAppSent) {
            <span class="margin-right-5">{{ 'WhatsApp Sent On' | translate }}</span>
          }
          @if (scheduling.lastSmsSentTimestamp) {
            <span class="margin-right-5">{{ scheduling | bringozFullDate:'lastSmsSentTimestamp' }}</span>
          }
          @if (scheduling.lastWhatsAppSentTimestamp) {
            <span class="margin-right-5">{{ scheduling | bringozFullDate:'lastWhatsAppSentTimestamp' }}</span>
          }
          @if (scheduling.numSmsSent) {
            <span class="margin-right-5">({{ scheduling.numSmsSent === 1 ? ('X_TIME' | translate) : ('X_TIMES' | translate:{num: scheduling.numSmsSent}) }})</span>
          }
          @if (scheduling.numWhatsAppSent) {
            <span class="margin-right-5">({{ scheduling.numWhatsAppSent === 1 ? ('X_TIME' | translate) : ('X_TIMES' | translate:{num: scheduling.numWhatsAppSent}) }})</span>
          }
        </div>
      </div>
    }
  </div>
}

<!--Billing order-->
@if (columns?.billingOrder?.enabled) {
  <div class="td col-billing-order">
    @if (order.billingOrderReference?.totalPrice) {
      <span class="text-ellipsis">{{ order.billingOrderReference.totalPrice | bringozPrice }}</span>
    }
  </div>
}

<!--Items Ids-->
@if (columns?.itemsIds?.enabled) {
  <div class="td col-items-ids">
    <app-bringoz-packages-items-display-list [isDisplayIds]="true"
                                             [items]="order.itemLines"></app-bringoz-packages-items-display-list>
  </div>
}

<!--Items Types-->
@if (columns?.itemsTypes?.enabled) {
  <div class="td col-items-types">
    <app-packages-indicator [packages]="order.itemLines"
                            [isShowFilterByButton]="true"
                            [maxDisplay]="1"
                            (onFilterByType)="onFilterByType.emit({type: $event.type, value: $event.value})">
    </app-packages-indicator>
  </div>
}

<!--Items Barcodes-->
@if (columns?.itemsBarcodes?.enabled) {
  <div class="td col-items-barcodes">
    <app-bringoz-items-list-display [items]="order.itemBarcodes"
                                    [maxItems]="1"
                                    [canCopy]="true">
    </app-bringoz-items-list-display>
  </div>
}

<!--Pallets-->
@if (columns?.pallets?.enabled) {
  <div class="td col-pallets">
    <span class="br-body-2 text-ellipsis">{{ order.itemLines | orderPallets:true }}</span>
  </div>
}

<!--Notes-->
@if (columns?.notes?.enabled) {
  <div class="td col-notes padding-0">
    <app-oms-orders-fulfillment-line-notes class="text-ellipsis" [order]="order">
    </app-oms-orders-fulfillment-line-notes>
  </div>
}

<!--Dynamic Columns-->
@for (metaData of enabledDynamicColumns; track metaData.cls) {
  <div class="td" [class]="metaData.cls">
    <span class="br-body-2 text-ellipsis">{{ order.metaData | bringozMetaDataDisplay: metaData }}</span>
  </div>
}

<!--Packages Dynamic Columns-->
@for (packageDynamicColumn of enabledPackageDynamicColumns; track packageDynamicColumn.cls) {
  <div class="td" [class]="packageDynamicColumn.cls">
    <span class="br-body-2 text-ellipsis">{{ order.itemLines | bringozPackagesCustomDataDisplay: packageDynamicColumn }}</span>
  </div>
}
